import { render, staticRenderFns } from "./CapituloCuatro18Page.vue?vue&type=template&id=49a7c4ca"
import script from "./CapituloCuatro18Page.js?vue&type=script&lang=js&external"
export * from "./CapituloCuatro18Page.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports